import { render, staticRenderFns } from "./question-set.vue?vue&type=template&id=c09001a0&"
import script from "./question-set.vue?vue&type=script&lang=js&"
export * from "./question-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports